import { api } from '@creditsights/api-ui-web';
import { FeedbackDto } from '../dtos/Feedback.dto';

export const submitFeedback = async (data: FeedbackDto): Promise<boolean> => {
  await api.post('/common/v1/feedback', data);
  return true;
};
